import find from 'lodash/find';
import { SiteType } from 'types/site.types';
const JourneyFilterReducer = (state, action) => {
    var _a, _b, _c, _d, _e, _f, _g;
    switch (action.type) {
        // Initialize the state with the initial values and no applied filters
        case 'INITIALIZE': {
            const allStepActivities = (action.steps || state.steps).flatMap(({ chainStepActivities }) => chainStepActivities);
            // Create a serialized list of all the connected activities from the steps
            const allStepActivityLinks = (action.steps || state.steps)
                .map(({ id: stepId, chainStepActivities }) => chainStepActivities
                .map(({ id: chainActivityId, incomingLinks, activity: { site } }) => {
                // If the activity has no incoming links, it is the first activity in the step (origin)
                if (incomingLinks.length === 0) {
                    return [
                        {
                            stepId,
                            targetActivity: {
                                id: chainActivityId,
                                locationCoordinates: site.siteType === SiteType.CLUSTER
                                    ? site.centroidCoordinates
                                    : site.locationCoordinates,
                            },
                        },
                    ];
                }
                return incomingLinks.map(({ chainStepActivityTargetId, chainStepActivitySourceId, transportationMode, }) => {
                    var _a;
                    const matchedSite = (_a = allStepActivities.find(({ id }) => id === chainStepActivitySourceId)) === null || _a === void 0 ? void 0 : _a.activity.site;
                    return {
                        stepId,
                        targetActivity: {
                            id: chainStepActivityTargetId,
                            locationCoordinates: site.siteType === SiteType.CLUSTER
                                ? site.centroidCoordinates
                                : site.locationCoordinates,
                        },
                        sourceActivity: matchedSite
                            ? {
                                id: chainStepActivitySourceId,
                                locationCoordinates: matchedSite.siteType === SiteType.CLUSTER
                                    ? matchedSite.centroidCoordinates
                                    : matchedSite.locationCoordinates,
                            }
                            : undefined,
                        transportationMode,
                    };
                });
            })
                .flat())
                .flat();
            const resetStepIndex = action.resetStepIndex === undefined || action.resetStepIndex === true;
            return Object.assign(Object.assign({}, state), { steps: (action.steps || state.steps).filter(({ chainStepActivities }) => !!chainStepActivities.length), allStepActivities,
                allStepActivityLinks, filteredSteps: action.steps || state.steps, allRawMaterials: action.allRawMaterials || state.allRawMaterials, filteredStepActivities: allStepActivities, filteredStepActivityLinks: allStepActivityLinks, selectedStepIndex: resetStepIndex ? 0 : state.selectedStepIndex, selectedStepActivityId: resetStepIndex
                    ? (_b = (_a = state.steps[state.selectedStepIndex]) === null || _a === void 0 ? void 0 : _a.chainStepActivities[0]) === null || _b === void 0 ? void 0 : _b.id
                    : state.selectedStepActivityId });
        }
        case 'SET_SELECTED_RAW_MATERIAL_ID': {
            if (action.id) {
                // Build a list beginning with the first step activity ids that contain the component id
                const initialMatchedActivityIds = state.allStepActivities
                    .filter((stepActivity) => {
                    var _a;
                    return ((_a = stepActivity.activity.component) === null || _a === void 0 ? void 0 : _a.rawMaterials.findIndex(({ id }) => id === action.id)) !== -1;
                })
                    .map(({ id }) => id);
                // Helper set to keep track of all the activities that are include the selected component
                const allFilteredStepActivitiesIdSet = new Set(initialMatchedActivityIds);
                const filteredSteps = state.steps
                    .map((step) => {
                    const newFilteredStepActivities = step.chainStepActivities.filter(({ id }) => allFilteredStepActivitiesIdSet.has(id));
                    // If no activities match with the current connectedMatchedActivityId in the step, skip this step
                    if (!newFilteredStepActivities.length) {
                        return Object.assign(Object.assign({}, step), { chainStepActivities: [] });
                    }
                    return Object.assign(Object.assign({}, step), { chainStepActivities: newFilteredStepActivities });
                })
                    .filter(({ chainStepActivities }) => chainStepActivities.length);
                const filteredStepActivities = state.allStepActivities.filter(({ id }) => allFilteredStepActivitiesIdSet.has(id));
                const filteredStepActivityLinks = state.allStepActivityLinks.filter(({ targetActivity, sourceActivity }) => allFilteredStepActivitiesIdSet.has(targetActivity.id) &&
                    (sourceActivity === null || sourceActivity === void 0 ? void 0 : sourceActivity.id) &&
                    allFilteredStepActivitiesIdSet.has(sourceActivity.id));
                const resetStepIndex = action.resetStepIndex === undefined || action.resetStepIndex === true;
                return Object.assign(Object.assign({}, state), { filteredSteps,
                    filteredStepActivities,
                    filteredStepActivityLinks, selectedRawMaterialId: action.id, selectedStepIndex: resetStepIndex ? 0 : state.selectedStepIndex, selectedStepActivityId: resetStepIndex
                        ? (_d = (_c = filteredSteps[0]) === null || _c === void 0 ? void 0 : _c.chainStepActivities[0]) === null || _d === void 0 ? void 0 : _d.id
                        : state.selectedStepActivityId });
            }
            // Else case to reset everything to the initial state
            const filteredSteps = state.steps.filter(({ chainStepActivities }) => !!chainStepActivities.length);
            return Object.assign(Object.assign({}, state), { filteredSteps, filteredStepActivities: state.allStepActivities, filteredStepActivityLinks: state.allStepActivityLinks, selectedRawMaterialId: undefined, selectedStepIndex: 0, selectedStepActivityId: (_f = (_e = filteredSteps[0]) === null || _e === void 0 ? void 0 : _e.chainStepActivities[0]) === null || _f === void 0 ? void 0 : _f.id });
        }
        case 'SET_SELECTED_ACTIVITY_ID': {
            const stepIndex = state.filteredSteps.findIndex(({ chainStepActivities }) => find(chainStepActivities, ['id', action.id]));
            if (stepIndex > -1 && !isNaN(stepIndex)) {
                return Object.assign(Object.assign({}, state), { selectedStepIndex: stepIndex, selectedStepActivityId: action.id });
            }
            console.error('Activity not found in the filtered steps');
            return state;
        }
        case 'SET_SELECTED_STEP_INDEX': {
            return Object.assign(Object.assign({}, state), { selectedStepIndex: action.index, selectedStepActivityId: (_g = state.filteredSteps[action.index].chainStepActivities[0]) === null || _g === void 0 ? void 0 : _g.id });
        }
        default:
            return state;
    }
};
export default JourneyFilterReducer;
